@if (selectedTour) {
  <div class="tour-context-header">
    <div class="tch-identity">
      <span class="tch-date">
        <i class="pi pi-calendar"></i>
        {{ formatFullDate(selectedTour.date) }}
      </span>
      <span class="tch-tech">
        <i class="pi pi-user"></i>
        {{ selectedTour.technicianName }}
      </span>
    </div>
    <div class="tch-meta">
      @if (startStep && endStep) {
        <span class="tch-meta-item">
          <i class="pi pi-clock"></i>
          {{ formatTime(startStep.departure) }} –
          {{ formatTime(endStep.arrival) }}
        </span>
      }
      @if (selectedTour.totalDurationMin != null) {
        <span class="tch-meta-item">
          <i class="pi pi-hourglass"></i>
          {{ formatDuration(selectedTour.totalDurationMin) }}
        </span>
      }
      @if (selectedTour.totalDistanceKm != null) {
        <span class="tch-meta-item">
          <i class="pi pi-directions"></i>
          {{ formatDistance(selectedTour.totalDistanceKm) }}
        </span>
      }
      @if (selectedTour.stopsCount != null) {
        <span class="tch-meta-item">
          <i class="pi pi-list"></i>
          {{ selectedTour.stopsCount }} étape{{
            selectedTour.stopsCount! > 1 ? 's' : ''
          }}
        </span>
      }
    </div>
    <div class="tch-actions">
      @if (canOpenTablotFiche && tablotFicheUrl) {
        <a
          class="fiche-link-btn"
          [href]="tablotFicheUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i class="pi pi-external-link"></i>
          Fiche
        </a>
      }
      @if (erosScheduleUrl) {
        <a
          class="fiche-link-btn"
          [href]="erosScheduleUrl"
          target="_blank"
          rel="noopener noreferrer"
          pTooltip="Valider une proposition et créer l'intervention sur EROS"
          tooltipPosition="left"
        >
          <i class="pi pi-external-link"></i>
          Programmer
        </a>
      }
      @if (manualScheduleAvailable) {
        <button
          type="button"
          class="fiche-link-btn"
          (click)="manualScheduleRequested.emit()"
          pTooltip="Valider un créneau et créer l'intervention sur EROS"
          tooltipPosition="left"
        >
          <i class="pi pi-bolt"></i>
          Programmer
        </button>
      }
      @if (manualDeleteAvailable) {
        <button
          type="button"
          class="fiche-link-btn fiche-link-danger"
          (click)="manualDeleteRequested.emit()"
          pTooltip="Supprimer cette affaire manuelle du vivier"
          tooltipPosition="left"
        >
          <i class="pi pi-trash"></i>
          Supprimer
        </button>
      }
      @if (googleMapsUrl) {
        <a
          class="fiche-link-btn"
          [href]="googleMapsUrl"
          target="_blank"
          rel="noopener noreferrer"
          pTooltip="Ouvrir l'itinéraire sur Google Maps"
          tooltipPosition="left"
        >
          <i class="pi pi-map"></i>
          Maps
        </a>
      }
    </div>
  </div>
}
